export default __webpack_public_path__ + "static/media/image4.c3f965ce.png";